// ─── ¿Ya empezó la sección? (H8) ────────────────────────────────────────────
// Decide qué deja una baja: ANTES del inicio, la inscripción se borra y no
// queda rastro en el expediente; DESDE el inicio, queda una «W».
//
// - La fecha de inicio es la de la sección o, si no tiene, la del período.
// - La marca del personal «forzar activa» (`lifecycleOverride: 'active'`) la da
//   por empezada.
// - Sin ninguna fecha, se la da por empezada: borrar lo que pudo cursarse sería
//   perder un registro; una W de más se corrige, un borrado no.
//
// `todayYmd` es HOY en la zona del seminario (`todayInZone`); las fechas se
// guardan a mediodía, así que su día de calendario no depende de la zona.
function ymd(d) {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${dd}`;
}
export function sectionHasStarted(params) {
    if (params.lifecycleOverride === 'active' || params.lifecycleOverride === 'concluded')
        return true;
    const start = params.sectionStartDate ? ymd(params.sectionStartDate) : params.termStartYmd;
    if (!start)
        return true;
    return params.todayYmd >= start;
}
//# sourceMappingURL=section-start.js.map